module.exports = __webpack_public_path__ + "visa.0922c6661e7f335928ab.svg";


//////////////////
// WEBPACK FOOTER
// /home/maheshreddy/PRP_FE/src/img/visa.svg
// module id = ../../../../../src/img/visa.svg
// module chunks = styles